import RequireIcon from '../RequireIcon';
import { input } from '../../utilities/inputObjects';
import { deleteControlCode } from '../../utilities/stringUtil';
import React, { useState } from 'react';
import * as _ from 'lodash';
import { FormElement } from '../CommonFormComponents';
import { CompanyBranchDropdown } from '../dropdowns/single/CompanyBranch';
import { PositionsDropdown } from '../dropdowns/single/Positions';
import { RadioButtonIcon } from '../icons/RadioButtonIcon';
import { ArrowDownIcon } from '../icons/ArrowDownIcon';
import {
  roleIdToJapaneseRoleName,
  isBranchRoleId,
  isManagerRoleId,
} from '../../utilities/roleUtility';
import { API_FLAG } from '../../utilities/constants';

/**
 *
 * @param companyBranchId
 * @param values
 * @param roles
 * @param disabledFields
 * @param forms
 * @param messages
 * @param newMode
 * @param jv
 * @param my_branch
 * @param callback
 * @returns {JSX.Element}
 * @constructor
 */
export const SupervisorForm = ({
  companyBranchId,
  values,
  roles,
  disabledFields,
  forms,
  messages,
  newMode,
  jv,
  my_branch,
  callback,
}) => {
  const [approvalSelect, setApprovalSelect] = useState(false);
  const renderRole = () => {
    if (roles.length === 1) {
      return (
        <input type='text' disabled={true} defaultValue={values.role_name} />
      );
    }
    return disabledFields.includes('role_code') ? (
      <input
        type='text'
        disabled
        value={roleIdToJapaneseRoleName(values.role_code)}
      />
    ) : (
      <div className='form-list-radio'>
        {_.map(roles, role => {
          return (
            <div className='form-list-radio__item' key={role.id}>
              <label className='radio'>
                <input
                  type='radio'
                  name='role_code'
                  value={role.id}
                  checked={values.role_code === role.id}
                  disabled={disabledFields.includes('role_code')}
                  onChange={e => {
                    if (e.target.checked) {
                      forms.set('role_code', parseInt(e.target.value, 10));
                    }
                    isManagerRoleId(Number(localStorage.getItem('role_id'))) ||
                    isBranchRoleId(role.id)
                      ? callback(API_FLAG.On)
                      : callback(API_FLAG.Off);
                    setTimeout(() => forms.isValid(true, 'role_code'), 100);
                  }}
                />
                <RadioButtonIcon className='icon--2x' />
                <span>{role.name}</span>
              </label>
            </div>
          );
        })}
      </div>
    );
  };

  const isTelEmptyAndDisabled = () => {
    return (
      _.isEmpty(values.tel1) &&
      _.isEmpty(values.tel2) &&
      _.isEmpty(values.tel3) &&
      disabledFields.includes('tel1') &&
      disabledFields.includes('tel2') &&
      disabledFields.includes('tel3')
    );
  };

  return (
    <ul className='form-list form-list-default form-list-default--space set-width-dropdown'>
      <li className='form-list__item'>
        <div className='form-list__label'>
          <span className='label'>
            役職
            <RequireIcon />
          </span>
        </div>
        <FormElement
          className='form-list__element'
          validate={messages.position_id}
        >
          <PositionsDropdown
            value={values.position_id}
            set={(key, id) => {
              forms.set(key, parseInt(id));
              setTimeout(() => {
                forms.isValid(true, 'position_id');
              }, 100);
            }}
            setkey='position_id'
            validate={() => {
              forms.isValid(true, 'position_id');
            }}
            isChildElement={true}
            params={{
              company_branch_id: companyBranchId,
              display_flag: 1,
            }}
          />
        </FormElement>
      </li>
      <li className='form-list__item'>
        <div className='form-list__label'>
          <span className='label'>
            承認権限
            <RequireIcon />
          </span>
        </div>
        <FormElement
          className='form-list__element'
          validate={messages.approval_level}
        >
          <select
            name='approval_level'
            className={approvalSelect ? 'show' : ''}
            onBlur={() => {
              if (approvalSelect) {
                setApprovalSelect(!approvalSelect);
              }
              forms.isValid;
            }}
            onChange={e => {
              if (approvalSelect) {
                setApprovalSelect(!approvalSelect);
              }
              forms.set('approval_level', deleteControlCode(e.target.value));
              setTimeout(() => forms.isValid(true, 'approval_level'), 100);
            }}
            onClick={() => {
              setApprovalSelect(!approvalSelect);
            }}
          >
            <option value=''>選択してください</option>
            <option value='1'>レベル1</option>
            <option value='2'>レベル2</option>
            <option value='3'>レベル3</option>
            <option value='4'>レベル4</option>
          </select>
          <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
        </FormElement>
      </li>
      <li className='form-list__item'>
        <div className='form-list__label'>
          <span className='label'>
            ユーザー種別
            {newMode && <RequireIcon />}
          </span>
        </div>
        <FormElement
          className='form-list__element'
          validate={messages.role_code}
        >
          {renderRole()}
        </FormElement>
      </li>

      <li className='form-list__item'>
        <div className='form-list__label'>
          <span className='label'>
            支店
            {newMode && <RequireIcon />}
          </span>
        </div>
        {disabledFields.includes('company_branch_id') ? (
          <FormElement className='form-list__element'>
            <input
              type='text'
              onBlur={forms.isValid}
              disabled={true}
              defaultValue={values.company_branch_name}
            />
          </FormElement>
        ) : (
          <FormElement className='' validate={messages.company_branch_id}>
            <CompanyBranchDropdown
              jv_company_branch_id={jv}
              my_branch={my_branch}
              name='company_branch_id'
              value={values.company_branch_id}
              set={(...arg) => {
                if (arg[1]) {
                  forms.set('company_branch_id', arg[1] ? arg[1] : '');
                  setTimeout(() => {
                    forms.isValid(true, 'company_branch_id');
                  }, 100);
                }
              }}
              setkey='company_branch_id'
              validate={() => forms.isValid(true, 'company_branch_id')}
              isChildElement={true}
              placeholder='支店を選択'
            />
          </FormElement>
        )}
      </li>

      <li className='form-list__item'>
        <div className='form-list__label'>
          <span className='label'>姓{newMode && <RequireIcon />}</span>
        </div>
        <FormElement
          className='form-list__element'
          validate={messages.name_sei}
        >
          <input
            type='text'
            name='name_sei'
            placeholder={
              !disabledFields.includes('name_sei') ? '（例）山田' : null
            }
            defaultValue={values.name_sei}
            onBlur={forms.isValid}
            onChange={e =>
              forms.set('name_sei', deleteControlCode(e.target.value))
            }
            disabled={disabledFields.includes('name_sei')}
          />
        </FormElement>
      </li>

      <li className='form-list__item'>
        <div className='form-list__label'>
          <span className='label'>名{newMode && <RequireIcon />}</span>
        </div>
        <FormElement
          className='form-list__element'
          validate={messages.name_mei}
        >
          <input
            type='text'
            name='name_mei'
            placeholder={
              !disabledFields.includes('name_mei') ? '（例）太郎' : null
            }
            className=''
            defaultValue={values.name_mei}
            onBlur={forms.isValid}
            onChange={e =>
              forms.set('name_mei', deleteControlCode(e.target.value))
            }
            disabled={disabledFields.includes('name_mei')}
          />
        </FormElement>
      </li>

      <li className='form-list__item'>
        <div className='form-list__label'>
          <span className='label'>
            せい
            {newMode && <RequireIcon />}
          </span>
        </div>
        <FormElement
          className='form-list__element'
          validate={messages.kana_sei}
        >
          <input
            type='text'
            name='kana_sei'
            placeholder={
              !disabledFields.includes('kana_sei') ? '（例）やまだ' : null
            }
            defaultValue={values.kana_sei}
            onBlur={forms.isValid}
            onChange={e =>
              forms.set('kana_sei', deleteControlCode(e.target.value))
            }
            disabled={disabledFields.includes('kana_sei')}
          />
        </FormElement>
      </li>

      <li className='form-list__item'>
        <div className='form-list__label'>
          <span className='label'>
            めい
            {newMode && <RequireIcon />}
          </span>
        </div>
        <FormElement
          className='form-list__element'
          validate={messages.kana_mei}
        >
          <input
            type='text'
            name='kana_mei'
            placeholder={
              !disabledFields.includes('kana_mei') ? '（例）たろう' : null
            }
            defaultValue={values.kana_mei}
            onBlur={forms.isValid}
            onChange={e =>
              forms.set('kana_mei', deleteControlCode(e.target.value))
            }
            disabled={disabledFields.includes('kana_mei')}
          />
        </FormElement>
      </li>

      <li className='form-list__item'>
        <div className='form-list__label'>
          <span className='label'>電話番号</span>
        </div>
        <FormElement className='form-list__element' validate={messages.tel}>
          {!isTelEmptyAndDisabled() && (
            <label htmlFor='tel' className='input-tel'>
              <input
                type='text'
                name='tel1'
                placeholder={!disabledFields.includes('tel1') ? '03' : null}
                maxLength='5'
                defaultValue={values.tel1}
                onChange={e =>
                  forms.set('tel1', deleteControlCode(e.target.value))
                }
                onBlur={e => forms.isValid(e, 'tel')}
                disabled={disabledFields.includes('tel1')}
              />
              <span>-</span>
              <input
                type='text'
                name='tel2'
                placeholder={!disabledFields.includes('tel2') ? '1234' : null}
                maxLength='4'
                defaultValue={values.tel2}
                onChange={e =>
                  forms.set('tel2', deleteControlCode(e.target.value))
                }
                onBlur={e => forms.isValid(e, 'tel')}
                disabled={disabledFields.includes('tel2')}
              />
              <span>-</span>
              <input
                type='text'
                name='tel3'
                placeholder={!disabledFields.includes('tel3') ? '4567' : null}
                maxLength='4'
                defaultValue={values.tel3}
                onChange={e =>
                  forms.set('tel3', deleteControlCode(e.target.value))
                }
                onBlur={e => forms.isValid(e, 'tel')}
                disabled={disabledFields.includes('tel3')}
              />
            </label>
          )}
        </FormElement>
      </li>

      <li className='form-list__item'>
        <div className='form-list__label'>
          <span className='label'>
            ユーザーID（メールアドレス）
            {newMode && <RequireIcon />}
          </span>
        </div>
        <FormElement className='form-list__element' validate={messages.email}>
          <input
            type='text'
            name='email'
            placeholder={
              !disabledFields.includes('email') ? 'メールアドレスを入力' : null
            }
            defaultValue={values.email}
            onBlur={forms.isValid}
            onChange={e =>
              forms.set('email', deleteControlCode(e.target.value))
            }
            disabled={disabledFields.includes('email')}
            className='form-list__input-large'
          />
        </FormElement>
      </li>
    </ul>
  );
};



// WEBPACK FOOTER //
// ./src/components/forms/SupervisorForm.jsx